import React from 'react';
// import jwt from "jsonwebtoken";
import axios from './axios';
import store from '../store';
import { LOAD_TOKEN, AUTH_ERROR } from '../actions/type';
import jwt_decode from 'jwt-decode';
import { baseURL } from './url';
import { decrypt } from './encodingdecoding';
// import { jwtDecode } from 'jwt-decode';

const EXPIRY_BUFFER_MS = 30 * 1000; // 30 seconds buffer

export const decodeTokenExpiry = (token) => {
	try {
		const decoded = jwt_decode(token);
		return decoded.exp * 1000;
	} catch {
		return 0;
	}
};

export const isTokenExpiredOrExpiring = (
	token,
	bufferMs = EXPIRY_BUFFER_MS,
) => {
	const expiry = decodeTokenExpiry(token);
	if (!expiry) return true;

	const now = Date.now();
	return expiry <= now + bufferMs;
};

export const isTokenExpired = (token) => {
	if (!token) return new Promise((resolve) => resolve(false));
	const now = new Date();
	if (token && jwt_decode(token)) {
		const expiry = jwt_decode(token);
		return new Promise((resolve) =>
			resolve(now.getTime() / 1000 + 60 < expiry.exp),
		);
	}
	return new Promise((resolve) => resolve(false));
};

export const getNewAuthToken = async () => {
	let body = {
		clientid: localStorage.getItem('clientid'),
		grant_type: 'client_credentials',
		clientsecret: localStorage.getItem('clientsecret'),
	};
	const { dispatch } = store;
	try {
		localStorage.removeItem('token_gen');
		const fetchResponse = await fetch(baseURL + 'internaltoken', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		});
		// fetchResponse.json().then((res) => {
		//     console.log(JSON.stringify(res))
		//     localStorage.setItem("token_gen",JSON.stringify(res));
		//     dispatch({ type: LOAD_TOKEN, payload: res.access_token });
		//     return fetchResponse.json();

		// })
		return await fetchResponse.json();
	} catch (err) {
		dispatch({ type: AUTH_ERROR });
		return new Promise((resolve) => resolve(null));
	}
};

// async handleLogout(err) {
//     const status = err?.response?.status;
//     if (status === 403) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 408) return store.dispatch({ type: AUTH_ERROR });
//     if (status === 418) {
//         const { dispatch } = store;
//         localStorage.removeItem("token");
//         const res = await axios.post("/api/authenticate");
//         const { token } = res.data.results;
//         dispatch({ type: LOAD_TOKEN, payload: token });
//         return store.dispatch({ type: AUTH_ERROR });
//     }
// }
// }

// export default new Utils();

export const CLIENT_ID = '548713b8-bd81-4c66-9f8c-0d3a7b8a461a-sasstest';
export const SECRET_KEY = 'CW5ALf4xVEegcf1CSBUkkkNJt3rszBVG';

export function buildQuery(baseUrl, params) {
	const queryString = Object.entries(params)
		.filter(
			([_, value]) =>
				value !== null && value !== undefined && value !== '',
		)
		.map(
			([key, value]) =>
				`${encodeURIComponent(key)}=${encodeURIComponent(
					String(value),
				)}`,
		)
		.join('&');

	return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}

export function sortByCategory(data) {
	const grouped = data.reduce((acc, item) => {
		const category = item.category || 'Unknown';
		if (!acc[category]) acc[category] = [];
		acc[category].push({
			...item,
			category,
			category_code: item.category_code || 'NA',
		});
		return acc;
	}, {});

	const sortedCategories = Object.keys(grouped).sort();

	const sortedGrouped = {};
	for (const category of sortedCategories) {
		sortedGrouped[category] = grouped[category];
	}

	return sortedGrouped;
}

export function rearrangeAgentFields(schema) {
	const priorityKeys = ['agentFirstName', 'agentLastName'];
	const reordered = {};

	priorityKeys.forEach((key) => {
		if (schema[key]) {
			reordered[key] = schema[key];
		}
	});

	Object.keys(schema).forEach((key) => {
		if (!priorityKeys.includes(key)) {
			reordered[key] = schema[key];
		}
	});

	return reordered;
}

export const sobiscoMerchantId = "MER010201"
export const novoNordiskMerchantId = "MER010195"
export const edsringMerchantId = "MER010193"

export const getUserTypeOptions = (merchantId) => {
	const isSobisco = merchantId === "MER010201";

	if (isSobisco) {
		return [
			{ label: "Distributor", value: "Distributor", customerType: "D" },
			{ label: "Wholesaler", value: "Wholesaler", customerType: "W" },
			{ label: "Sales", value: "Sales", customerType: "S" },
		];
	}

	return [
		{ label: "Distributor", value: "Distributor", customerType: "D" },
		{ label: "Retailers", value: "Retailer", customerType: "R" },
		{ label: "Customer", value: "CustomerCP", customerType: "C" },
		{ label: "Influencer", value: "Influencer", customerType: "I" },
		{ label: "Admin User", value: "Admin", customerType: "A" },
	];
};

export function liveDashboardId(id) {
	switch (true) {
		case ["MER000252", "MER000289", "MER010193", "MER010191", "MER010201", "MER010195", "MER010190"].includes(id):
			return true;

		default:
			return false;
	}
}
